import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdBarChart, MdLeaderboard, MdMic, MdSchool, MdPayments } from 'react-icons/md';
import MainLayout from '../../components/Layout/MainLayout';

const reportLinks = [
  {
    title: 'Summary Dashboard',
    description: 'System-wide KPIs for HR, candidates, interviews, exams and payments.',
    path: '/reports/summary',
    icon: MdBarChart
  },
  {
    title: 'HR Performance',
    description: 'Monthly HR productivity, attendance, leaves, interviews and selection rate.',
    path: '/reports/hr-performance',
    icon: MdLeaderboard
  },
  {
    title: 'Interview Report',
    description: 'Candidate interview outcomes with filters by date range and HR.',
    path: '/reports/interviews',
    icon: MdMic
  },
  {
    title: 'Exam Report',
    description: 'Exam scores with pass/fail analytics and average score trend.',
    path: '/reports/exams',
    icon: MdSchool
  },
  {
    title: 'Payment Report',
    description: 'Base salary, incentives and payout status by HR for a selected month.',
    path: '/reports/payments',
    icon: MdPayments
  }
];

const ReportsHomePage = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <div className="max-w-7xl mx-auto p-4">
        <h1 className="text-3xl font-bold text-charcoal">Reports Module</h1>
        <p className="text-sm text-gray-600 mt-2">
          Production reports with filters, charting, exports, and pagination.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {reportLinks.map((item) => (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="text-left rounded-xl border border-gray-200 bg-white shadow-sm p-5 hover:shadow-md hover:border-olive/50 transition"
            >
              <item.icon className="text-3xl text-olive" />
              <h2 className="text-lg font-semibold text-charcoal mt-4">{item.title}</h2>
              <p className="text-sm text-gray-600 mt-2 leading-relaxed">{item.description}</p>
            </button>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default ReportsHomePage;
